import { render, staticRenderFns } from "./bowmanTest.vue?vue&type=template&id=38d411e0&scoped=true"
import script from "./bowmanTest.vue?vue&type=script&lang=js"
export * from "./bowmanTest.vue?vue&type=script&lang=js"
import style0 from "./bowmanTest.vue?vue&type=style&index=0&id=38d411e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d411e0",
  null
  
)

export default component.exports